export default "__VITE_ASSET__Db1ugd$N__"